module.exports = __webpack_public_path__ + "media/images/emoticons/chick-9d3c4a90484a931dc96666f3bb0cbaba.gif";